import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  text: {
    marginRight: 5,
  },
  count: {
    color: theme.palette.grey[500],
  },
}));
